import ReduxState from "../state";

type State = ReduxState["startTime"];

const initialState: State = Date.now();

export default function startTimeReducer(state: State = initialState): State {
  return state;
}
